import { PickupStatus } from "../../../app/data/common/route";
import { ManifestStopProfileRaw, PickupProfile } from "../../../app/data/manifest/manifestProfiles";

export type ManifestWorkProgress = {
  completedStops: number;
  totalStops: number;
  completedPickups: number;
  totalPickups: number;
  combinedPercent: number;
  label: string;
};

export function isStopComplete(stop: { stopStatus: string }): boolean {
  return stop.stopStatus === "complete";
}

export function isPickupComplete(pickup: PickupProfile): boolean {
  return pickup.pickupStatus === PickupStatus.COMPLETED;
}

export function getManifestWorkProgress(
  rowStopsTotal: number,
  stops: ManifestStopProfileRaw[],
  pickups: PickupProfile[] = [],
): ManifestWorkProgress {
  const completedStops = stops.filter(isStopComplete).length;
  const totalStops = rowStopsTotal;
  const completedPickups = pickups.filter(isPickupComplete).length;
  const totalPickups = pickups.length;

  const workTotal =
    (totalStops > 0 ? totalStops : 0) + (totalPickups > 0 ? totalPickups : 0);
  const workCompleted =
    (totalStops > 0 ? completedStops : 0) +
    (totalPickups > 0 ? completedPickups : 0);

  // totalStops comes from the row summary; completedStops from the stops array (same API response, separate fields).
  const combinedPercent =
    workTotal > 0 ? Math.min(100, Math.floor((workCompleted / workTotal) * 100)) : 0;

  const labelParts: string[] = [];
  if (totalStops > 0) labelParts.push(`${completedStops}/${totalStops} stops`);
  if (totalPickups > 0) labelParts.push(`${completedPickups}/${totalPickups} pickups`);

  return {
    completedStops,
    totalStops,
    completedPickups,
    totalPickups,
    combinedPercent,
    label: labelParts.join(" · ") || "—",
  };
}
